<template>
  <div class="column100 overflow-auto">
    <div class="informasi-row-odd-wrapper">
      <div class="column50">
        <div class="gray500">Badan Usaha</div>
        <div class="gray700">
          {{ information && $get(information, 'badan_usaha.alias_profile') }}
        </div>
      </div>
      <div class="column50">
        <div class="gray500">Bidang Usaha</div>
        <div class="gray700">
          {{
            information &&
              $get(information, 'badan_usaha.bidang_usaha.desc', '-')
          }}
        </div>
      </div>
    </div>
    <div class="informasi-row-even-wrapper">
      <div class="column100">
        <div class="gray500">Alamat</div>
        <div class="gray700">{{ information.alamat }}</div>
        <div class="gray700">
          {{ $get(information, 'kelurahan.desc', '-') }},
          {{ $get(information, 'kecamatan.desc', '-') }},
          {{
            $get(information, 'negara.id') == 63
              ? $get(information, 'provinsi.desc', '-')
              : $get(information, 'provinsi_asing', '-')
          }},
          {{
            $get(information, 'negara.id') == 63
              ? $get(information, 'kelurahan.kodepos', '-')
              : $get(information, 'kode_pos_asing', '-')
          }}, {{ $get(information, 'negara.negara') }}
        </div>
      </div>
    </div>
    <div class="informasi-row-odd-wrapper">
      <div class="column50">
        <div class="gray500">No. Handphone</div>
        <div class="gray700">
          {{ information && $get(information, 'no_handphone', '-') }}
        </div>
      </div>
      <div class="column50 col-break">
        <div class="gray500">Email</div>
        <div class="gray700">
          {{ information && $get(information, 'email', '-') }}
        </div>
      </div>
    </div>
    <div class="informasi-row-even-wrapper">
      <div class="column100">
        <div class="gray500 text-bold">Person In Charge (PIC)</div>
        <div
          class="informasi-pic-container"
          v-if="information && information.pic && information.pic.length > 0"
        >
          <div class="informasi-pic-wrapper" v-for="list in information.pic">
            <div class="informasi-pic">
              <div class="informasi-pic-icon">
                <img :src="require(`~/assets/img/icons/avatar.png`)" alt="" />
              </div>
              <div class="informasi-pic-detail">
                <div class="text-bold gray700">
                  {{ list.nama }}
                </div>
                <div class="gray600">{{ list.email }}</div>
                <div class="gray600">{{ list.no_handphone }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="informasi-row-odd-wrapper">
      <div class="column100">
        <div class="gray500">NPWP</div>
        <div class="gray700">
          {{ information && $get(information, 'no_npwp', '-') }}
        </div>
      </div>
    </div>
    <div class="informasi-row-even-wrapper">
      <div class="column100">
        <div class="gray500">Hubungan Dengan Sinarmas Mining Group</div>
        <div class="gray700">
          {{
            information.afiliasi_bce == 1 ||
            information.afiliasi_gems == 1 ||
            information.afiliasi_bkes == 1
              ? 'Affiliated -'
              : 'Tidak ada Afiliasi'
          }}
          {{ information.afiliasi_bce == 1 ? 'BCE' : null }}
          {{ information.afiliasi_gems == 1 ? 'GEMS' : null }}
          {{ information.afiliasi_bkes == 1 ? 'BKES' : null }}
        </div>
      </div>
    </div>
    <div class="informasi-row-odd-wrapper">
      <div class="column100">
        <div class="gray500 text-bold">
          Identitas Nama Orang Yang Bersangkutan
        </div>
        <div
          class="informasi-pic-container"
          v-if="
            information.afiliasi_bce == 1 ||
              information.afiliasi_gems == 1 ||
              information.afiliasi_bkes == 1
          "
        >
          <div class="informasi-pic-wrapper">
            <div class="informasi-pic-icon">
              <img :src="require(`~/assets/img/icons/avatar.png`)" alt="" />
            </div>
            <div class="informasi-pic-detail">
              <div class="text-bold gray700">
                {{
                  information.relasi_nama_bce ||
                    information.relasi_nama_gems ||
                    information.relasi_nama_bkes
                }}
              </div>
              <div class="gray600">
                {{
                  information.relasi_jabatan_bce ||
                    information.relasi_jabatan_gems ||
                    information.relasi_jabatan_bkes
                }}
              </div>
            </div>
          </div>
        </div>

        <div class="informasi-pic-container" v-else>
          <div class="informasi-pic-wrapper">
            <div class="informasi-pic-icon">
              <img :src="require(`~/assets/img/icons/avatar.png`)" alt="" />
            </div>
            <div class="informasi-pic-detail">
              <div class="text-bold gray700">
                -
              </div>
              <div class="gray600">-</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  computed: {
    information() {
      const infoList = this.$store.state.level1.information
      return infoList
    },
  },
  methods: {},
}
</script>
